import '@/i18n'
import router from '@/router'
import {
  fetchAreaPrefecturesMap,
  fetchIndustries,
  fetchInterests,
  fetchLanguages,
  fetchOccupations,
  fetchProgramTypes,
  fetchQualifications,
  fetchSchools,
  fetchSkills,
} from '@/util/ref'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import 'bootstrap/dist/css/bootstrap.min.css'
import { StrictMode, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import '@/index.css'
import { useEffect } from 'react'
import { fetchAuthURL } from './util/auth'
import { queryClient } from './util/queryClient'
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN
Sentry.init({
  dsn: dsn,
  sendDefaultPii: true
})

// TODO: maybe remove prefetching
queryClient.prefetchQuery({
  queryKey: ['area-prefecture'],
  queryFn: fetchAreaPrefecturesMap,
  staleTime: Infinity,
})

queryClient.prefetchQuery({
  queryKey: ['industry'],
  queryFn: fetchIndustries,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['interest'],
  queryFn: fetchInterests,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['language'],
  queryFn: fetchLanguages,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['occupation'],
  queryFn: fetchOccupations,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['program-type'],
  queryFn: fetchProgramTypes,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['qualification'],
  queryFn: fetchQualifications,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['school'],
  queryFn: fetchSchools,
  staleTime: 1000 * 60 * 5,
})

queryClient.prefetchQuery({
  queryKey: ['skill'],
  queryFn: fetchSkills,
  staleTime: 1000 * 60 * 5,
})

export function AppInitializer({ children }: { children: React.ReactNode }) {
  const [initialized, setInitialized] = useState(false)
  useEffect(() => {
    fetchAuthURL().then(() => setInitialized(true))
  }, [])
  if (initialized) return <>{children}</>
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppInitializer>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </AppInitializer>
  </StrictMode>
)
